import React from 'react';

export const UserContext = React.createContext()


// WEBPACK FOOTER //
// ./src/contexts/index.js